module.exports = __webpack_public_path__ + "static/media/ChefPort_Logo.24ef4ae7.png";